import IconBase from "../IconBase";

const LinkIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M10 13C10.4295 13.5742 10.9774 14.0492 11.6066 14.393C12.2357 14.7367 12.9315 14.9411 13.6467 14.9924C14.3618 15.0436 15.0796 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4508 9.59702 21.9548 8.334 21.9434 7.02302C21.932 5.71204 21.4061 4.45797 20.4791 3.53093C19.5521 2.60389 18.298 2.07805 16.987 2.06666C15.676 2.05526 14.413 2.55924 13.47 3.47003L11.75 5.18003"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M14 11C13.5705 10.4259 13.0226 9.95086 12.3934 9.6071C11.7642 9.26334 11.0685 9.05893 10.3533 9.00771C9.63819 8.95649 8.9204 9.05967 8.24864 9.31026C7.57688 9.56085 6.96687 9.95297 6.45999 10.46L3.45999 13.46C2.5492 14.4031 2.04522 15.6661 2.05662 16.977C2.06801 18.288 2.59385 19.5421 3.52089 20.4691C4.44793 21.3962 5.702 21.922 7.01298 21.9334C8.32396 21.9448 9.58697 21.4408 10.53 20.53L12.24 18.82"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default LinkIcon;
